module.exports = __webpack_public_path__ + "static/media/Light_horizontal.d7920a80.svg";